export const GoldDivider = ({ className = "" }) => (
    <div className={`flex items-center justify-center gap-3 ${className}`} aria-hidden="true">
        <span className="h-px w-16 sm:w-24 bg-gradient-to-r from-transparent to-gold/60" />
        <svg width="46" height="14" viewBox="0 0 46 14" fill="none" className="text-gold/80">
            <path d="M23 1 L28 7 L23 13 L18 7 Z" stroke="currentColor" strokeWidth="1" fill="none" />
            <circle cx="23" cy="7" r="1.4" fill="currentColor" />
            <path d="M8 7 H15 M31 7 H38" stroke="currentColor" strokeWidth="0.8" />
            <circle cx="5" cy="7" r="1" fill="currentColor" opacity="0.7" />
            <circle cx="41" cy="7" r="1" fill="currentColor" opacity="0.7" />
        </svg>
        <span className="h-px w-16 sm:w-24 bg-gradient-to-l from-transparent to-gold/60" />
    </div>
);
